export default __webpack_public_path__ + "static/media/bg-retangles-horizontal.c9c5dca6.png";